var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19693 0.946777L0.58499 9.81246C0.349647 11.1101 3.45747 11.7162 3.40589 13.0363L3.0029 23.514C2.94165 25.1259 4.61484 25.1259 4.61484 25.1259C4.61484 25.1259 6.28804 25.1259 6.22679 23.514L5.8238 13.0363C5.77383 11.7178 8.6173 11.1342 8.6447 9.81246L7.03276 0.946777H6.22679L6.62977 7.39455L5.42082 8.20052L5.01783 0.946777H4.21186L3.80887 8.20052L2.59992 7.39455L3.0029 0.946777H2.19693ZM15.8984 0.946777C14.712 0.946777 12.7326 2.0026 11.9411 3.58553C11.2802 4.77192 11.0626 7.42356 11.0626 9.00649V13.0363C11.0626 14.3549 12.8196 14.6483 13.4805 14.6483L12.6746 23.514C12.5295 25.1195 14.2865 25.1259 14.2865 25.1259C14.2865 25.1259 15.8984 25.1259 15.8984 23.514V0.946777Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoon);
export default __webpack_public_path__ + "static/media/spoon.ab80dfefed180177355a1ff62a0c895f.svg";
export { ForwardRef as ReactComponent };